import { GET_LETIAN_STAFF_QT,
    GET_LETIAN_STAFF_QT_SUCCESS,
    GET_LETIAN_STAFF_QT_FAIL,
    QUICK_TRANSFER_ORDERS_QT,
    QUICK_TRANSFER_ORDERS_QT_SUCCESS,
    QUICK_TRANSFER_ORDERS_QT_FAIL,
    GET_LETIAN_STAFF_QT_TEMP,
    GET_LETIAN_STAFF_QT_TEMP_SUCCESS,
    GET_LETIAN_STAFF_QT_TEMP_FAIL } from '../actions/types';

const initialState = {
    getLetianStaffLoading: false,
    getLetianStaff: [],
    getLetianStaffError: false,
    quickTransferOrdersLoading: false,
    quickTransferOrders: [],
    quickTransferOrdersError: false,
    getLetianStaffTempLoading: false,
    getLetianStaffTemp: [],
    getLetianStaffTempError: false,
}

export default function qtReducer(state = initialState, action){
    switch(action.type){
        case GET_LETIAN_STAFF_QT_TEMP:
            return {
                ...state,
                getLetianStaffTempLoading: true,
            }
        case GET_LETIAN_STAFF_QT_TEMP_SUCCESS:
            return {
                ...state,
                getLetianStaffTemp: action.payload,
                getLetianStaffTempLoading: false
            }
        case GET_LETIAN_STAFF_QT_TEMP_FAIL:
            return {
                ...state,
                getLetianStaffTempLoading: false,
                getLetianStaffTempError: action.payload
            }
        case GET_LETIAN_STAFF_QT:
            return {
                ...state,
                getLetianStaffLoading: true,
            }
        case GET_LETIAN_STAFF_QT_SUCCESS:
            return {
                ...state,
                getLetianStaff: action.payload,
                getLetianStaffLoading: false
            }
        case GET_LETIAN_STAFF_QT_FAIL:
            return {
                ...state,
                getLetianStaffLoading: false,
                getLetianStaffError: action.payload
            }
        case QUICK_TRANSFER_ORDERS_QT:
            return {
                ...state,
                quickTransferOrdersLoading: true,
            }
        case QUICK_TRANSFER_ORDERS_QT_SUCCESS:
            return {
                ...state,
                quickTransferOrders: action.payload,
                quickTransferOrdersLoading: false
            }
        case QUICK_TRANSFER_ORDERS_QT_FAIL:
            return {
                ...state,
                quickTransferOrdersLoading: false,
                quickTransferOrdersError: action.payload
            }
        default:
            return state;
    }
} 